import React from 'react';
import { ShieldCheckIcon, StarIcon } from 'lucide-react';
import { CTAButton } from './CTAButton';
import { OFFER_ANCHOR, PRODUCT_IMAGE } from '../data/constants';
export function Hero() {
  return <section className="border-b-4 border-burnt bg-espresso px-4 py-6 text-cream" data-id="element-90" data-mp="9ka2qpx8ocsp">
      <div className="mx-auto max-w-3xl text-center" data-id="element-91" data-mp="4lyuukqi8cd4">
        <p className="mb-2 inline-block rounded border border-gold bg-gold/15 px-2 py-1 text-[0.65rem] font-extrabold uppercase tracking-widest text-gold sm:text-xs" data-id="element-92" data-mp="4n9wof0e3a1l">
          One Complete 6-in-1 System
        </p>
        <h1 className="text-2xl sm:text-4xl" data-id="element-93" data-mp="x8b6lljh351s">
          The Complete Cinnamon Roll System To{' '}
          <span className="text-gold" data-id="element-94" data-mp="sde1uqt87hup">Start Selling From Home</span>
        </h1>
        <p className="mx-auto mt-2 max-w-2xl text-sm font-medium leading-snug text-cream/85 sm:text-base" data-id="element-95" data-mp="nbonb16som1v">
          Stop saving recipes, watching random tutorials, and wondering how to turn homemade cinnamon rolls into
          something people will actually want to buy.
        </p>
        <p className="mx-auto mt-1.5 max-w-2xl text-sm font-bold leading-snug text-cream sm:text-base" data-id="element-96" data-mp="3j9u06x1wdkkr">
          Learn how to create irresistible cinnamon rolls and turn what you bake into a real income opportunity.
        </p>
        <a href={OFFER_ANCHOR} className="mt-3 block focus:outline-none focus-visible:ring-4 focus-visible:ring-gold/60" data-id="element-97" data-mp="39cfjqxfz4vsg">
          <img src={PRODUCT_IMAGE} alt="CINNAMON ROLL BUSINESS™ — the ultimate business bundle box set with 6 modules" className="mx-auto w-full max-w-xs drop-shadow-2xl sm:max-w-sm" data-id="element-98" data-mp="30i158x39ppae" />
        </a>
        <div className="mx-auto mt-3 max-w-md" data-id="element-99" data-mp="2ql6ampa4891e">
          <CTAButton href={OFFER_ANCHOR} data-id="element-100" data-mp="2viy1dfz0xp40">🍥 YES! I WANT TO START NOW</CTAButton>
        </div>
        <p className="mt-2 inline-flex items-center gap-1.5 text-xs font-bold text-gold" data-id="element-101" data-mp="2vglld8cttotl">
          <ShieldCheckIcon className="h-4 w-4" aria-hidden="true" data-id="element-102" data-mp="2hl9r122l20d7" /> 14-Day Money-Back Guarantee — Zero Risk
        </p>
        <p className="mt-1 flex items-center justify-center gap-1 text-[0.7rem] font-semibold text-cream/70" data-id="element-103" data-mp="s21hwapu6bzg">
          <StarIcon className="h-3.5 w-3.5 fill-gold text-gold" aria-hidden="true" data-id="element-104" data-mp="nbl0ygmt488c" /> Immediate digital access
        </p>
      </div>
    </section>;
}